<template>
    <div>
        <Snackbar
            v-if="showSnackbar"
            :snackbarColor="snackbarColor"
            :snackbarMessage="snackbarMessage"
            @close="closeSnackbar()"
        >
        </Snackbar>
        <div class="content_box_for_tnc">
              <v-card class="settings_panel_card" flat>
                <v-toolbar flat dense class="settings_toolbar">
                    
                    <v-toolbar-title class="settings_panel_heading">Terms and Conditions ( {{ tncStatus ? 'Default' : 'Custom'}} )</v-toolbar-title>

                    <v-spacer></v-spacer>
                    
                    <div v-show="tnCPanel">
                        <v-btn icon depressed small v-if="isEditable && !disabletncChild" @click="editConfiguration">
                            <v-icon>create</v-icon>
                        </v-btn>

                        <v-btn icon v-if="!isEditable" @click="saveEditedChanges(false)">
                            <v-icon>check</v-icon>
                        </v-btn>

                        <v-btn icon v-if="!isEditable" @click="cancelEditedConfiguration">
                            <v-icon>clear</v-icon>
                        </v-btn>

                        <v-btn color="#736B63" dark small depressed id="enableTNC" v-if="disabletncChild" @click="saveEditedChanges(true)">
                            Enable Tnc
                        </v-btn>

                        <v-btn color="#736B63" dark small depressed  id="disableTNC" v-if="!disabletncChild" @click="saveEditedChanges(true)">
                            Disable TnC
                        </v-btn>
                    </div>

                    <v-btn icon @click="tnCPanel = true" v-show="!tnCPanel">
                        <v-icon>keyboard_arrow_down</v-icon>
                    </v-btn>

                </v-toolbar>
                <!-- <v-divider></v-divider> -->
                <div v-if="tnCPanel" class="terms-and-conditions__section">
                    <v-layout row wrap>
                        <v-flex xs1 class="ml-4 my-3 grey--text">
                            <b>Number Of Days</b>
                        </v-flex>
                        <v-flex xs10 class="ml-4 my-3">
                        <input type="text" maxlength="6" v-model="selectedNum" class="inputcallbackheader" :readonly="isEditable">
                        </v-flex>
                        
                        <v-flex xs1 class="ml-4 my-3 grey--text">
                            <b>Terms & Conditions</b>
                        </v-flex>
                        <v-flex xs8 class="ml-4 my-3">
                        <textarea class="certificateConfiguration inputcallbackheader" v-model="tnccontent" :readonly="isEditable"></textarea>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Snackbar from "../../../common/components/snackbar"
import {hideLoadIcon,showLoadIcon} from '../../../common/assets/utils/load.js';
export default {
    name:'tncConfiguration',
    props: {
        appid: {
            type: Number,
            default: null
        },
        schemaname:{
            type:String,
            default:null
        },
        disabletnc:{
            type: Boolean,
            default: false
        },
        nodeValue:{
            type:String,
            default:null
        }
    },
    data(){
        return{
            isEditable:true,
            selectedNum: 1,
            tnccontent: null,
            tnCPanel: false,
            tncStatus: 'Default',
            showSnackbar:false,
            snackbarColor : null,
            snackbarMessage: null,
            disabletncChild: this.disabletnc,
            hide:null
        }
    },
    components: {
        Snackbar,
    },
    created() {
        this.getTnCDetails();
    },
    watch: {
        appid(){
            this.getTnCDetails();
        },
        selectedNum(nval, oval){
            this.selectedNum = isNaN(this.selectedNum) ? oval : this.selectedNum ;
            if(this.selectedNum < 0){
                this.selectedNum = oval
            }
        },
    },
    methods:{
        editConfiguration(){
            var self = this;
            self.isEditable = false;
        },
        cancelEditedConfiguration(){
            var self = this;
            self.isEditable = true;
            self.tnCPanel = false;
        },
        getTnCDetails(){
            if(!this.disabletncChild){
                var self = this;
                showLoadIcon();
                this.$loading(true);
                Vue.http.get('/apptoken_tnc', {
                    params: {'app_id': self.appid ,'node':self.nodeValue}
                })
                .then((res) => {
                    try{
                        if(res.data){
                            self.selectedNum = res['data']['days'] || 1;
                            self.tnccontent = res['data']['content'] || '';
                            self.tncStatus = res['data']['default_tnc'] || false;
                        }
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    //console.log("api failed with error");
                });
            }
        },
        saveEditedChanges(disabletncFlag){
            var self = this, formData = new FormData();
            formData.append('json', JSON.stringify({
                    'app_id': self.appid,
                    'content':self.tnccontent,
                    'num_days': self.selectedNum,
                    'disable_tnc': disabletncFlag ? !self.disabletncChild : self.disabletncChild,
                    'default_tnc':self.tncStatus,
                    'node':self.nodeValue}));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/apptoken_tnc/',formData)
            .then((res)=>{
                try{
                    self.isEditable = true;
                    self.disabletncChild = disabletncFlag ? !self.disabletncChild : self.disabletncChild;
                    self.snackbarMessage = res.data.message ? res.data.message : 'Successfully saved details';
                    self.displaySnackbar('success-banner',self.snackbarMessage);
                    if(disabletncFlag){
                        self.$emit('action')
                }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error)=>{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.isEditable = true;
                self.snackbarMessage = error.data.message ? error.data.message : 'Unable to save data' ;
                self.displaySnackbar('error-banner',self.snackbarMessage);
            })
        },
        // Functions to display snackbar for success/error messages
        displaySnackbar(color,message){
            var self = this;
            self.showSnackbar = false;
            setTimeout(function(){
                self.showSnackbar = true;
            },100)
            self.snackbarColor = color;
            self.snackbarMessage = message;
        },
        closeSnackbar(){
            var self = this;
            self.showSnackbar = false;
            self.snackbarColor = null;
            self.snackbarMessage = null;
        },
        showLoadIcon,
        hideLoadIcon
    }
}
</script>
<style lang="scss">
.terms-and-conditions__section {
    margin-left: 1rem;
}
</style>
